import { aws_exports as config, Image } from '@akin-home/amplify';
import { LocalImage } from '@akin-home/images';
import { v4 as uuid } from 'uuid';
import { createImageMutation } from '../api/mutations';
import { fetchFileBlob } from './fetchFileBlob';
import { postImageBlobToS3 } from './postImageBlobToS3';

interface PostImageParams {
  habitatID?: string;
  readGroups?: string[];
  file: LocalImage;
}

export const postImageToCloud = async ({
  habitatID,
  readGroups,
  file,
}: PostImageParams): Promise<Image> => {
  const name = file.filename || habitatID || 'file';
  const data = {
    key: `${uuid()}${name}`,
    region: config.aws_user_files_s3_bucket_region,
    bucket: config.aws_user_files_s3_bucket,
  };

  const blob = await fetchFileBlob(file);

  await postImageBlobToS3(data.key, blob, file.mime);
  // TODO Add S3 delete if image creation fails
  const res = await createImageMutation({ name, habitatID, readGroups, data });

  return res.createImage as Image;
};
